"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Icon_1 = require("../../Icon");
var StackView_1 = require("../../StackView");
var Text_1 = require("../../Text");
var helpers_1 = require("../../helpers");
var LinkButton_1 = require("../../controls/LinkButton");
var Tooltip_1 = require("../../Tooltip");
var helpers_2 = require("../cellRenderers/helpers");
var View_1 = require("../../View");
var svg_1 = require("../svg");
var icons_1 = require("../../icons");
var TitleWithTooltipWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    min-width: ", ";\n\n    ", " {\n        margin-left: ", ";\n    }\n"], ["\n    display: flex;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    min-width: ", ";\n\n    ", " {\n        margin-left: ", ";\n    }\n"])), helpers_1.SPACING_M, Text_1.Text.selector, helpers_1.SPACING_S);
var TitleWithTooltip = function (_a) {
    var text = _a.text, rest = __rest(_a, ["text"]);
    var ref = react_1.useRef(null);
    return Tooltip_1.useTooltip({
        renderContent: function () { return react_1.default.createElement(helpers_2.TooltipText, { size: Text_1.TEXT_SIZE.s }, text); },
        render: function (tooltipProps) {
            return (react_1.default.createElement(TitleWithTooltipWrapper, __assign({}, rest, { onMouseEnter: function () {
                    helpers_2.onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref)();
                }, onMouseLeave: function () {
                    tooltipProps.onMouseLeave();
                }, ref: ref }),
                react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.LargeInfoStatusIcon, null) }),
                react_1.default.createElement(Text_1.Text, { truncate: true }, text)));
        }
    });
};
var RefreshWrapper = styled_components_1.default(StackView_1.StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    overflow: hidden;\n"], ["\n    overflow: hidden;\n"])));
exports.refreshNotificationRenderer = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.text, text = _c === void 0 ? 'The data set has been changed.' : _c, _d = _b.refreshTextButton, refreshTextButton = _d === void 0 ? 'Refresh' : _d, _e = _b.ignoreTextButton, ignoreTextButton = _e === void 0 ? 'Ignore' : _e, _f = _b.onRefresh, onRefresh = _f === void 0 ? function () { } : _f, _g = _b.onIgnore, onIgnore = _g === void 0 ? function () { } : _g;
    return (react_1.default.createElement(RefreshWrapper, { spaceFill: View_1.SPACE_FILL.all, gap: StackView_1.STACK_GAP.l },
        react_1.default.createElement(TitleWithTooltip, { "data-selector-id": "refresh-notification-text", text: text }),
        react_1.default.createElement(LinkButton_1.LinkButton, { "data-selector-id": "refresh-link", compact: true, iconBefore: react_1.default.createElement(svg_1.Refresh, null), onClick: function (e) {
                e.preventDefault();
                onRefresh();
            } }, refreshTextButton),
        react_1.default.createElement(LinkButton_1.LinkButton, { "data-selector-id": "ignore-link", compact: true, iconBefore: react_1.default.createElement(svg_1.Ignore, null), onClick: function (e) {
                e.preventDefault();
                onIgnore();
            } }, ignoreTextButton)));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=refreshNotificationRenderer.js.map